export default (function (str) {
  return "".concat(str.charAt(0).toUpperCase()).concat(str.slice(1));
});